import { render, staticRenderFns } from "./DetailsMenu.vue?vue&type=template&id=7ce6669c&scoped=true&"
import script from "./DetailsMenu.vue?vue&type=script&lang=js&"
export * from "./DetailsMenu.vue?vue&type=script&lang=js&"
import style0 from "./DetailsMenu.vue?vue&type=style&index=0&id=7ce6669c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce6669c",
  null
  
)

export default component.exports